import { Plugin } from '@nuxt/types';
import { createBridge, isBridgeApp } from '@eg/delfi-app-bridge/dist/web';

const initAppBridge: Plugin = async (_, inject) => {
  const appBridge = isBridgeApp() ? createBridge({ timeoutMs: 1000 }) : null;

  inject('appBridge', appBridge);
};

export default initAppBridge;
